import LinearProgressProps from './type';
import { LinearProgressColorStyled, LinearProgressWrapperStyled } from './styled';

const LinearProgress = ({ ...props }: LinearProgressProps) => {
  const { containerStyle, contentStyle, ...rest } = props;
  return (
    <LinearProgressWrapperStyled style={containerStyle}>
      <LinearProgressColorStyled {...rest} style={contentStyle} />
    </LinearProgressWrapperStyled>
  );
};

LinearProgress.defaultProps = {
  value: 0,
  size: '12px',
};

export default LinearProgress;
